import {Component, Inject, OnInit} from '@angular/core';
import {Meta, Title} from '@angular/platform-browser';
import {UtilitiesService} from '../service/utilities.service';
import {DOCUMENT} from '@angular/common';

@Component({
    selector: 'app-platform',
    templateUrl: './platform.component.html',
    styleUrls: ['./platform.component.scss']
})
export class PlatformComponent implements OnInit {

    constructor(@Inject(DOCUMENT) public document: Document,
                private title: Title,
                private meta: Meta,
                private utilities: UtilitiesService) {
    }

    ngOnInit(): void {
        let title: string = 'Solar Central | About This Platform | Let us help you find the most competitive quotes';
        let keywords: string = 'solar systems Gauteng, Limpopo, North West, Mpumalanga, Free State, Northern Cape, Western Cape, Eastern Cape, Kwazulu-Natal, KZN, Kwazulu Natal, build your personalised system, most competitive quotes, request for solar quotation, best solar companies in south africa, solar system cost';
        let description: string = 'If you are looking for solar systems in Gauteng, Limpopo, North West, Mpumalanga, Free State, Northern Cape, Western Cape, Eastern Cape, KwaZulu-Natal (or anywhere in between), you can rest assured that we will help you find the best solar deals in your area!';

        this.title.setTitle(title);
        this.meta.updateTag({name: 'twitter:title', content: title});
        this.meta.updateTag({name: 'og:title', content: title});

        this.meta.updateTag({name: 'keywords', content: keywords});
        this.meta.updateTag({name: 'twitter:keywords', content: keywords});
        this.meta.updateTag({name: 'og:keywords', content: keywords});

        this.meta.updateTag({name: 'description', content: description});
        this.meta.updateTag({name: 'twitter:description', content: description});
        this.meta.updateTag({name: 'og:description', content: title});

        this.meta.updateTag({ name: 'date', content: this.utilities.formatDate(new Date()), scheme: 'YYYY-MM-DD' });
    }
}
